<template>
    <div id="chartSymbolSelector">
        <div class="print:hidden">
            <slot name="buttons" v-if="section"></slot>
        </div>

        <div class="border-t-2 border-blue-600">
            <div class="tan-control-box pb-1">
                <div class="select-title pt-1 pb-1 print:hidden">Select:</div>

                <template v-if="section === 'futures'">
                    <contract-selector
                        v-model="symbol"
                        :initial="sectionQuotes.symbol"
                        :all-contracts="sectionQuotes.futures"
                    />
                    <div class="ml-1 mb-1 text-center flex md:inline-flex md:justify-start justify-center items-center print:hidden">
                        <div @click="goToSymbol" class="btn btn-yellow btn-sm">Draw Futures Chart</div>
                    </div>
                </template>

                <template v-if="section === 'forex'">
                    <forex-selector
                        v-model="symbol"
                        :default-symbol="defaultSymbol"
                        :symbols="sectionQuotes.forex"
                    />
                    <div class="ml-1 mb-1 text-center flex md:inline-flex md:justify-start justify-center items-center print:hidden">
                        <div @click="goToSymbol" class="btn btn-yellow btn-sm">Draw Forex Chart</div>
                    </div>
                </template>

                <template v-if="section === 'future-spreads'">
                    <div class="flex flex-wrap" id="selectFutureSpreads">
                        <spread-selector
                            v-model="symbol"
                            :default-symbol="defaultSymbol"
                            :default-contract="sectionQuotes.underlying"
                            :spreads="sectionQuotes.spreads"
                            :all-contracts="sectionQuotes.futures"
                        />
                    </div>
                    <div class="ml-1 mb-1 text-center flex md:inline-flex md:justify-start justify-center items-center print:hidden">
                        <div @click="goToSymbol" class="btn btn-yellow btn-sm">Draw Spread Chart</div>
                    </div>
                </template>

                <template v-if="section === 'crypto'">
                    <forex-selector
                        v-model="symbol"
                        :default-symbol="defaultSymbol"
                        :symbols="sectionQuotes.crypto"
                    />
                    <div class="ml-1 mb-1 text-center flex md:inline-flex md:justify-start justify-center items-center print:hidden">
                        <div @click="goToSymbol" class="btn btn-yellow btn-sm">Draw Crypto Chart</div>
                    </div>
                </template>

                <template v-if="section === 'stock-etf'" class="relative">
                    <stock-search-selector v-model="symbol" />
                    <div class="ml-1 mb-1 text-center flex md:inline-flex md:justify-start justify-center items-center print:hidden">
                        <div @click="goToSymbol" class="btn btn-yellow btn-sm">Draw Equities Chart</div>
                    </div>
                </template>

                <template v-if="section === 'future-options'">
                    <option-selector-2
                        v-model="symbol"
                        :initial-symbol="sectionQuotes.underlying"
                        :groups="sectionQuotes.options || sectionQuotes.quotes"
                    />
                    <div class="w-auto ml-1 text-center align-top flex justify-center mb-1 print:hidden">
                        <div @click="goToSymbol" class="btn btn-yellow btn-sm">Draw Futures Options Chart</div>
                    </div>
                </template>
            </div>

            <alert-box v-if="!defaultSymbol">
                <template #body>
                    Please select a symbol
                </template>
            </alert-box>

        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    section: {
        type: String,
        required: true
    },
    sectionQuotes: {
        type: [Array, Object],
        // required: true
    },
    templates: {
        type: Array,
        required: true
    },
    // Is this required??
    // chartBooks: {
    // 	type: Array,
    // 	required: true
    // },
    defaultSymbol: String,
    quotes: [Array, Object]
});

const symbol = ref(props.defaultSymbol || '');
// const showChart = ref(false);
// const chartRecord = ref(false);
// // const quotes = ref({});
// const error = ref(false);

// function getChart() {
//     const route = window.route('interactive-charts.symbol', {
//         section: props.section,
//         symbol: symbol.value
//     });

//     return axios.get(route)
//         .then((response) => {
//             chartRecord.value = response.data.chart;
//             quotes.value = response.data.quotes;
//         }).catch((error) => {
//             error.value = true;
//         })
// }

function goToSymbol() {
    const route = window.route('interactive-charts.symbol', {
        section: props.section,
        symbol: symbol.value
    });

    window.location = route.toString();
}
</script>

<style lang="scss">
#chartSymbolSelector {
    .form-control {
        @apply mb-1;
    }
    .btn-table-action {
        @apply ml-1;
    }
    #selectFutureSpreads {
        & > span {
            display: flex;
            flex-wrap: wrap;
        }
        select {
            width: 100%;
        }
    }
}
</style>